@let alertType = type();

<div
    role="alert"
    class="flex flex-col items-start gap-2 py-4 px-6 rounded-2xl border-1 last:[&>div>p]:mb-0 alert"
    [class]="{
        'danger-alert': alertType === 'danger',
        'warning-alert': alertType === 'warning',
        'info-alert': alertType === 'info',
        'success-alert': alertType === 'success',
    }">
    @if (title()) {
        <h5 class="mb-0 leading-6 flex">
            @let icon = iconMap[alertType];
            @if (icon) {
                <big-icon
                    [icon]="icon"
                    [size]="'w-6'"
                    [inline]="true"
                    class="mr-2 fill-current shrink-0 align-top" />
                <div class="translate-y-[0.1em]">{{ title() }}</div>
            }
        </h5>
    }
    <ng-content />
</div>
